import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import { loadAppConfig } from '@/composables/useAppConfig'

// 自定义插件

// import XdvideoPlayer from '@platform/xdvideo-player-vue2';
// import '@platform/xdvideo-player-vue2/dist/xdvideo-player-vue2.css';

// Vue.use(XdvideoPlayer);

const app = createApp(App)

app.use(store)
app.use(router)

// 提前触发 config 加载, 让路由首次导航守卫的 await stageStore.whenReady() 有信号可等
// 不 await, 与 router.isReady() 并发进行 (最坏也就是首屏等 config 完成)
loadAppConfig()

router.isReady().then(() => {
  app.mount('#root')
})
